var _rect, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 7.5,
    fill: "#F0F3F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4167 14.7788V5.55555H13.5833V14.7028L15.9209 12.3653L16.7458 13.1903L13.0162 16.9199L8.99323 13.2064L9.78455 12.3491L12.4167 14.7788Z",
    fill: "#092658"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.91667 14.8611V16.9445C6.91667 17.5418 6.91737 17.9459 6.94878 18.2546C6.9792 18.5537 7.03352 18.698 7.09924 18.7963C7.17828 18.9146 7.27984 19.0162 7.39813 19.0952C7.4965 19.1609 7.64079 19.2153 7.93981 19.2457C8.24858 19.2771 8.65267 19.2778 9.25 19.2778H16.75C17.3473 19.2778 17.7514 19.2771 18.0602 19.2457C18.3592 19.2153 18.5035 19.1609 18.6019 19.0952C18.7202 19.0162 18.8217 18.9146 18.9008 18.7963C18.9665 18.698 19.0208 18.5537 19.0512 18.2546C19.0826 17.9459 19.0833 17.5418 19.0833 16.9445V14.8611H20.25V16.9746C20.25 17.5341 20.25 17.9979 20.2119 18.3727C20.1721 18.764 20.086 19.1225 19.8708 19.4445C19.7067 19.6902 19.4957 19.9011 19.25 20.0653C18.928 20.2804 18.5695 20.3665 18.1783 20.4063C17.8035 20.4445 17.3397 20.4445 16.7801 20.4445H9.21987C8.66032 20.4445 8.19654 20.4445 7.82173 20.4063C7.43047 20.3665 7.07198 20.2804 6.74997 20.0653C6.50429 19.9011 6.29335 19.6902 6.12919 19.4445C5.91403 19.1225 5.82791 18.764 5.78811 18.3727C5.74998 17.9979 5.74999 17.5341 5.75 16.9746L5.75 14.8611H6.91667Z",
    fill: "#092658"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 7.5,
    stroke: "#DCE0E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.76aeb9c55a1dd2aae2266dd392b2bc99.svg";
export { ForwardRef as ReactComponent };